<rb-dialog (buttonClick)="onDialogButtonClick($event)" [config]="dialogConfig">
  <form [formGroup]="form" class="flex flex-col gap-y-[4rem]">
    <rb-form-field [label]="'APP.DOCUMENT.RENAME_DOCUMENT.NAME.LABEL' | translate"
                   [required]="true">
      <div class="flex items-center">
        <mat-form-field [class.no-error]="!validatorService.errorMatches(form.controls.name, errorKey$ | async)"
                        class="grow">
          <input [placeholder]="'APP.DOCUMENT.RENAME_DOCUMENT.NAME.PLACEHOLDER' | translate"
                 formControlName="name"
                 matInput
                 required />
        </mat-form-field>
        <span>.{{ document.extension }}</span>
      </div>
    </rb-form-field>
  </form>
</rb-dialog>
